const bodyElement = document.getElementsByTagName("body")[0];
const headerChangeClassName = 'header-notScrolled';
const headerChangeOffset = 20;
let isScrolled = false;

window.addEventListener('scroll', () => {
    let y = (window.scrollY || window.pageYOffset)
    y = y < 1 ? 1 : y // ensure y is always >= 1 (due to Safari's elastic scroll)
    
    if (y > headerChangeOffset) {
        if (!isScrolled) { 
            bodyElement.classList.remove(headerChangeClassName)
            isScrolled = true;
        }
    }
    else {
        if (isScrolled) {
            bodyElement.classList.add(headerChangeClassName)
            isScrolled = false;
        }
    }
  });